import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "submitButton",
    "errorMessage",
    "currentCredits",
    "requiredCredits",
  ];
  static values = { statusUrl: String };

  connect() {
    this.modals = {
      prompt: this.initModal("#promptInput"),
      loading: this.initModal("#loadingModal"),
      credits: this.initModal("#insufficientCreditsModal"),
    };
  }

  async submitForm(event) {
    event.preventDefault();
    if (this.isSubmitting) return;

    try {
      this.isSubmitting = true;
      this.disableForm();

      this.hideModal("prompt");

      const response = await fetch(this.formTarget.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(new FormData(this.formTarget)),
      });

      const data = await this.handleResponse(response);
      if (data?.id) await this.pollImageStatus(data.id);
    } catch (error) {
      await this.handleError(error);
    } finally {
      this.isSubmitting = false;
      this.enableForm();
      this.cleanupModals();
    }
  }

  async handleResponse(response) {
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw {
        status: response.status,
        message: data.error || "Request failed",
        current_credits: data.current_credits,
        required_credits: data.required_credits,
      };
    } else {
      this.showModal("loading");
    }
    return data;
  }

  async pollImageStatus(imageId) {
    try {
      const response = await fetch(`${this.statusUrlValue}/${imageId}/status`);
      const data = await response.json();

      if (data.status === "completed") window.location.reload();
      if (data.status === "failed") throw new Error(data.error_message);
      setTimeout(() => this.pollImageStatus(imageId), 2000);
    } catch (error) {
      this.handleError(error);
    }
  }

  async handleError(error) {
    console.error("Error:", error);
    this.hideModal("loading");

    if ([422, 402].includes(error?.status)) {
      this.showCreditsError({
        error: error.message || "Insufficient credits",
        current_credits: error.current_credits ?? "N/A",
        required_credits: error.required_credits ?? "N/A",
      });
    } else {
      alert(error.message || "An unexpected error occurred");
      console.log(error);
    }
  }

  showCreditsError(data) {
    this.errorMessageTarget.textContent = data.error;
    this.currentCreditsTarget.textContent = data.current_credits;
    this.requiredCreditsTarget.textContent = data.required_credits;
    this.showModal("credits");
  }

  initModal(selector) {
    const element = document.querySelector(selector);
    return element ? new bootstrap.Modal(element) : null;
  }

  cleanupModals() {
    // Remove Bootstrap backdrop
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.remove();

    // Reset body styles
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }

  showModal(name) {
    if (this.modals[name]) this.modals[name].show();
  }

  hideModal(name) {
    if (this.modals[name]) this.modals[name].hide();
  }

  disableForm() {
    this.submitButtonTarget.disabled = true;
    this.submitButtonTarget.style.opacity = "0.5";
  }

  enableForm() {
    this.submitButtonTarget.disabled = false;
    this.submitButtonTarget.style.opacity = "1";
  }
}
